button.scroll-navigation-arrow {
  --icon-size: min(5vw, 2.5rem);
  /* see ListScroller.module.css */
  --halfGutters: calc(var(--rds-gutter) / 2);
  --offset: calc(var(--halfGutters) - var(--icon-size) / 2);

  display: none;
  position: absolute;
  left: max(var(--offset), 1rem);
  box-sizing: content-box;
  padding: 0.5rem;
  transition: transform 0.25s ease;
  cursor: pointer;
  z-index: 99;
  background-color: var(--rds-button-tertiary-bg);

  &:hover,
  &:focus {
    /* In the hero scroller opacity is set to 0.5 when not hovered */
    opacity: 1;
    background-color: var(--rds-button-tertiary-hover-bg);
  }

  &.right {
    left: unset;
    right: max(var(--offset), 1rem);

    & .inner-icon {
      transform: rotate(180deg);
    }
  }

  &.with-border {
    border: 2px solid #267c82;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0;
  }

  & .inner-icon {
    max-height: var(--icon-size);
    max-width: var(--icon-size);
    color: white;
    height: var(--icon-size);
    width: var(--icon-size);
    margin: 0;
  }
}
